/**
 * Bulk Operations Type Definitions
 * Shared types for batch operations across Components, Failure Modes, Root Causes, and Mitigations
 */
/**
 * Mitigation action status
 */
export var MitigationStatus;
(function (MitigationStatus) {
    MitigationStatus["NOT_PLANNED"] = "NOT_PLANNED";
    MitigationStatus["PLANNED"] = "PLANNED";
    MitigationStatus["IN_PROGRESS"] = "IN_PROGRESS";
    MitigationStatus["IMPLEMENTED"] = "IMPLEMENTED";
    MitigationStatus["VERIFIED"] = "VERIFIED";
})(MitigationStatus || (MitigationStatus = {}));
/**
 * Type guards for discriminating entity types
 */
export function isBulkEntityType(value) {
    return [
        'Component',
        'FailureMode',
        'RootCause',
        'Mitigation',
        'ComponentFailureLink',
        'FailureCauseLink',
        'CommissioningActivity',
    ].includes(value);
}
export function isBulkOperationType(value) {
    return [
        'delete',
        'update-status',
        'assign-category',
        'link',
        'unlink',
        'update-verification',
        'update-mitigation-status',
        'update-commissioning-status',
    ].includes(value);
}
export function isMitigationStatus(value) {
    return Object.values(MitigationStatus).includes(value);
}
/**
 * Error codes for bulk operations
 */
export var BulkOperationErrorCode;
(function (BulkOperationErrorCode) {
    BulkOperationErrorCode["ENTITY_NOT_FOUND"] = "ENTITY_NOT_FOUND";
    BulkOperationErrorCode["ENTITY_DELETED"] = "ENTITY_DELETED";
    BulkOperationErrorCode["VALIDATION_FAILED"] = "VALIDATION_FAILED";
    BulkOperationErrorCode["PERMISSION_DENIED"] = "PERMISSION_DENIED";
    BulkOperationErrorCode["CONFLICT"] = "CONFLICT";
    BulkOperationErrorCode["INVALID_STATE"] = "INVALID_STATE";
    BulkOperationErrorCode["CIRCULAR_REFERENCE"] = "CIRCULAR_REFERENCE";
    BulkOperationErrorCode["MAX_DEPTH_EXCEEDED"] = "MAX_DEPTH_EXCEEDED";
    BulkOperationErrorCode["DUPLICATE_LINK"] = "DUPLICATE_LINK";
    BulkOperationErrorCode["DATABASE_ERROR"] = "DATABASE_ERROR";
    BulkOperationErrorCode["UNKNOWN_ERROR"] = "UNKNOWN_ERROR";
})(BulkOperationErrorCode || (BulkOperationErrorCode = {}));
//# sourceMappingURL=bulkOperations.types.js.map